import styled from 'styled-components'

export const StyledBabyPoop = styled.div``
